<div class="app-container">
  <loading-spinner
    [isLoading]="queryTag.isPending() || queryTagTypes.isPending()"
    [classesString]="'top-50'"
    [spinnerOverlayAddedClass]="'pe-none'"
  ></loading-spinner>
  <!--  pokud penduje nacitani queryTag -->
  @if (isCreating() || (!isCreating() && !this.queryTag.isPending() && !this.queryTagTypes.isPending())) {
    <form [formGroup]="tagForm" (ngSubmit)="isCreating() ? mutationCreateTag.mutate() : mutationUpdateTag.mutate()">
      <page-header
        [icon]="'fa-tag'"
        [title]="isCreating() ? 'tag.new' : ''"
        [appendNoTranslationTitlePart]="isCreating() ? '' : queryTag.data()?.name"
      >
        <!--      todo solve : queryTag.data()?.name-->
        <ng-container class="header-button">
          <!--      todo solve : disabled if form invalid ???-->
          <btn
            [label]="'save'"
            [title]="'save' | translate"
            [icon]="'far-check'"
            [btnType]="'submit'"
            [classes]="['btn-first', 'float-right']"
            [isLoading]="this.mutationCreateTag.isPending() || this.mutationUpdateTag.isPending()"
            [spinnerClassesString]="'spinner-white'"
            [btnDisabled]="!!tagForm.errors"
            [dataCyAttribute]="'create-tag'"
          ></btn>
          <!--        todo queryTag.data()?.id-->
          <!--        *ngIf="la()"-->
          @if (queryTag.data()?.id) {
            <btn
              [label]="'tag.delete'"
              [title]="'tag.delete' | translate"
              [icon]="'far-trash-alt'"
              [btnType]="'button'"
              (onEvent)="mutationDelete.mutate()"
              [classes]="['btn-first-red', 'float-right', 'me-2']"
              [isLoading]="this.mutationDelete.isPending()"
              [spinnerClassesString]="'spinner-white'"
              [dataCyAttribute]="'delete-tag'"
            ></btn>
          }
        </ng-container>
        <ng-container class="back-button">
          <btn
            [label]="'back'"
            [title]="'back' | translate"
            [isBackButton]="true"
            [classes]="['btn-third', 'float-right', 'me-2']"
            [icon]="'far-arrow-left'"
            (onEvent)="goBack()"
          ></btn>
        </ng-container>
      </page-header>
      <section class="content">
        <div class="card">
          <div class="row">
            <div class="col-12">
              <form-row-input
                [formGroup]="tagForm"
                formControlName="name"
                [required]="tagForm.get('name').errors !== null && tagForm.get('name').errors.required"
                [requiredCssClass]="submitted() && formControls.name.errors"
                [icon]="'fa-id-badge'"
                [label]="'tag.name'"
                [dataCyAttribute]="'name'"
              ></form-row-input>
              <form-row-select
                [formGroup]="tagForm"
                formControlName="type"
                [required]="tagForm.get('type').errors !== null && tagForm.get('type').errors.required"
                [requiredCssClass]="submitted() && formControls.type.errors"
                [label]="'tag.type'"
                [translationPrefix]="'tags.type.'"
                [options]="this.queryTagTypes.data()"
                [inputDisabled]="!isCreating()"
                [dataCyAttribute]="'tag-type-select'"
              ></form-row-select>
              <form-row-input
                [formGroup]="tagForm"
                formControlName="color"
                [icon]="'fa-tint'"
                [label]="'tag.color'"
                [inputType]="'color'"
              ></form-row-input>
              <form-row-input
                [formGroup]="tagForm"
                formControlName="externalId"
                [label]="'externalId'"
                [dataCyAttribute]="'external-id'"
              ></form-row-input>
            </div>
          </div>
        </div>
      </section>
    </form>
  }
</div>
